import * as React from "react";
import { forwardRef } from "react";
const SvgSecondaryCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 19, viewBox: "0 0 17 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.1668 5L6.37516 13.25L2.8335 9.5", stroke: "#55AFB0", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSecondaryCheckmark);
export { ForwardRef as ReactComponent };
